import React, {FC, ReactNode} from 'react';
import {Box, Typography} from "@mui/material";

interface MessageErrorsProps {
    children: ReactNode,
  fontSize?: string
}

const MessageErrors: FC<MessageErrorsProps> = ({children,fontSize}) => {
    return (
        <Box marginTop={1}>
            <Typography component={'span'}
                        className={`!text-red-500 ${fontSize ? fontSize : '!text-sm'} !font-[500] !leading-[140%] !tracking-[0.015em] !whitespace-normal`}>
                {children}
            </Typography>
        </Box>
    );
};

export default MessageErrors;